<template>
<div>
    <b-col class="mt-2" sm="12" md="12" lg="12">
    <b-card v-bind:img-src="product.img_url" img-alt="Card image" img-top class="mb-3">
      <b-card-text>
        <b-row class="mt-1 mb-1 text-left">
            <b-col><h5>{{ product.name }}</h5></b-col>
        </b-row>
        <b-row cols="2">
            <b-col sm class="text-success">Price: ${{ product.price }}</b-col>
            <b-col sm><b-icon-box-seam/> Stock: {{ product.stock }}</b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col><span class="btn" @click="addToCart(product.id)"><b-icon-cart/> Add to Cart</span></b-col>
        </b-row>
      </b-card-text>
    </b-card>
    </b-col>
</div>
</template>

<script>
export default {
  name: 'Card',
  props: ['product'],
  methods: {
    addToCart (ProdId) {
      if (localStorage.access_token) {
        this.$store.dispatch('addToCart', ProdId)
        this.$store.dispatch('fetchAllCarts')
      } else {
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>

<style>

</style>
